module.exports = __webpack_public_path__ + "img/medical-slimming-wellness.ac0e1da2.png";